var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackgroundMobileBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 428,
    height: 482,
    viewBox: "0 0 428 482",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M404.842 -132.324C409.003 -131.197 412.253 -127.947 413.38 -123.786L505.834 217.647C506.969 221.841 505.775 226.322 502.703 229.395L253.813 478.284C250.741 481.356 246.26 482.551 242.066 481.415L-99.3678 388.962C-103.529 387.835 -106.779 384.585 -107.906 380.424L-200.359 38.9902C-201.495 34.7963 -200.3 30.3152 -197.228 27.2429L51.6614 -221.647C54.7338 -224.719 59.2148 -225.913 63.4087 -224.778L404.842 -132.324Z",
    fill: "#005977"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M647.27 -374.537C651.431 -373.41 654.681 -370.16 655.807 -365.999L748.261 -24.5655C749.397 -20.3716 748.202 -15.8906 745.13 -12.8182L496.241 236.071C493.168 239.144 488.687 240.338 484.493 239.202L143.06 146.749C138.899 145.622 135.649 142.372 134.522 138.211L42.0683 -203.223C40.9327 -207.417 42.127 -211.898 45.1994 -214.97L294.089 -463.859C297.161 -466.932 301.642 -468.126 305.836 -466.99L647.27 -374.537Z",
    fill: "#005977"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundMobileBlue);
export default __webpack_public_path__ + "static/media/background_mobile_blue.e59c96cd905ce76e9d5a6a478ddd2af8.svg";
export { ForwardRef as ReactComponent };